import { Component, Inject, OnDestroy, PLATFORM_ID, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { HttpService } from '../../../shared/services/http.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { MatDialog } from '@angular/material/dialog';
import { SharedModelComponent } from '../../../shared/components/shared-model/shared-model.component';
import { ChooseLocationModalComponent } from '../../../shared/components/choose-location-modal/choose-location-modal.component';
import { Subscription, lastValueFrom } from 'rxjs';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { environment } from '../../../environments/environment';
import { DataLayerService } from '../../../shared/services/gtm-service/data-layer.service';
import { ServerSideResponseService } from '../../../shared/services/server-side-response.service';
import { SchemaService } from '../../../shared/services/schema.service';
import { JsonDataService } from '../../../shared/services/json-data.service';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FaqPageComponent } from '../faq-page/faq-page.component';
import { FiltersComponent } from '../filters/filters.component';
import { ProductCardComponent } from '../product-card/product-card.component';
@Component({
  selector: 'app-product-listing',
  standalone: true,
  imports: [CommonModule, RouterModule, FaqPageComponent, FiltersComponent, ProductCardComponent],
  templateUrl: './product-listing.component.html',
  styleUrl: './product-listing.component.scss'
})
export class ProductListingComponent implements OnDestroy {
  private _routerSub = Subscription.EMPTY;
  private _routeSub = Subscription.EMPTY;
  private eshopCatSub = Subscription.EMPTY;
  private sub = new Subscription();
  environment: any = environment;
  productList: any = [];
  subCatGuid: any;
  filterData: any;
  isEshop: any;
  seriesGuid: any = '';
  script: any;
  actualSchemaValue: any;
  plpText: any;
  filtersApplied: any = [];
  selectedDataForBreadCrumb: any;
  staticFilterForSort = {
    filterID: 'sb',
    filterNames: 'Sort By',
    filterDisplayNames: 'Sort By',
    filterValues: [
      {
        filterValue: "Featured",
        filterDisplayValue: "Featured",
        filterValueId: 1,
        sortByDescending: false,
        checked: true
      },
      {
        filterValue: "Price",
        filterDisplayValue: "Price-Low To High",
        filterValueId: 5,
        sortByDescending: false
      },
      {
        filterValue: "Price",
        filterDisplayValue: "Price-High To low",
        filterValueId: 6,
        sortByDescending: true
      }
    ]
  };
  faqData!: any[];
  parentName: any;
  isCompare: boolean = false;
  submitProducts: any;
  checkedProducts: any = [];
  plpMetaData: any;
  pageName!: string;
  subcatName!: string;
  seriesName!: string;
  structuredData!: SafeHtml;
  paths: any = []
  comparedata: any;
  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private httpSvc: HttpService, private serverResponse: ServerSideResponseService,
    private dataLayerService: DataLayerService, public analytisService: AnalyticsService,
    public utils: UtilsService, private route: ActivatedRoute, public dialog: MatDialog,
    public router: Router, private metaSvc: MetaMgmtService, private schemaService: SchemaService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private jsonDataService: JsonDataService, private sanitizer: DomSanitizer) {
    this.getJsonData();
    this.getJsonDataAsync();
  }

  async getJsonDataAsync() {
    // if (isPlatformBrowser(this.platformId)) {

    try {
      const res = await lastValueFrom(this.jsonDataService.getProductListingMetaDataJsonData());
      this.plpMetaData = res;
      const resolvedData = this.route.snapshot.data['resolvedData'];
      if (resolvedData && resolvedData.res && resolvedData.res.url) {
        this.serverResponse.setStatusCode(301);
        this.router.navigate([resolvedData.res.url]);
      } else {
        this.utils.showHeaderFooter.next(true);
        this.sub.add(this._routerSub = this.route.params.subscribe((params: any) => {
          this.subCatGuid = params['guid'] ? params['guid'] : '';
          this.subcatName = params['plpFor'] ? params['plpFor'] : '';
          this.pageName = params['plpFor'];
          this.parentName = params['parentName'] ? params['parentName'] : '';
          this.plpText = params['plpFor'] ? params['plpFor'].split('-').join(' ') : '';
          this.seriesName = params['seriesName'] ? params['seriesName'] : '';
          this.isEshop = params['parentName'] == 'shop-now' ? true : false;
          localStorage.setItem('source', this.isEshop ? 'Eshop' : 'Brand');
          let canonicalUrl = environment.baseApiURl + this.router.url;
          let metaDataFilter: any;
          if (this.seriesName != '') {
            metaDataFilter = this.plpMetaData.filter((x: any) => {
              if ((this.seriesName == x.name) && (this.isEshop == x.isEshop)) return x;
            });

          } else {
            const plpTextWordCount = this.plpText.split(/\s+/).length;

            if (plpTextWordCount > 1) {
              const plpTextData = this.plpText.replace(/ /g, '-');
              metaDataFilter = this.plpMetaData.filter((x: any) => {
                if ((plpTextData == x.name) && (this.isEshop == x.isEshop)) return x;
              });
            } else {
              metaDataFilter = this.plpMetaData.filter((x: any) => {
                if ((params['plpFor'] == x.name) && (this.isEshop == x.isEshop)) return x;
              });
            }
          }
          if (this.isEshop && metaDataFilter[0] && metaDataFilter[0].isEshop) {
            this.plpText = metaDataFilter[0].displayName ? metaDataFilter[0].displayName : '';
          }
          let metaData: any = {
            seriesName: this.seriesName,
            canonicalURL: canonicalUrl,
            description: metaDataFilter[0] && metaDataFilter[0].description ? metaDataFilter[0].description : '',
            pageTitle: metaDataFilter[0] && metaDataFilter[0].title ? metaDataFilter[0].title : '',
            keywords: metaDataFilter[0] && metaDataFilter[0].keywords ? metaDataFilter[0].keywords : ''
          }
          this.metaSvc.updateMetaTags(metaData);
          this.utils.filterQueryObj = { queryObj: {}, apiObjArr: {} };
          if (this.isEshop) {
            this.analytisService.triggerplpViewed(this.plpText, this.isEshop)
          }
          else {
            this.analytisService.triggerplpViewed(this.plpText, this.isEshop)
          }
          this.staticFilterForSort.filterValues.reduce((accumulator: any, currentValue: any) => {
            if (currentValue.filterValueId == 1) {
              currentValue['checked'] = true;
            }
            else {
              currentValue['checked'] = false;
            }
          }
            , null
          )
          if (this._routeSub) this.sub.add(this._routeSub.unsubscribe());
          this.inIt()
        }))
      }
      // }
    } catch (error) {
      console.error('Error', error);
    }

  }

  matchesAnyPath(): string | null {
    return this.paths.find((path: any) => this.router.url.includes(path)) || null;
  }


  ngOnInit() {
    if (!this.isSchemaAdded()) {
      this.callSchema();
    }
  }
  private isSchemaAdded(): any {
        if(isPlatformBrowser(this.platformId)) { 
    
    // Check if schema is present in the document
    const existingSchema = this._document.querySelector('script[type="application/ld+json"]');
    return !!existingSchema; // Returns true if schema is present, false otherwise
  }
}
  getJsonData() {
    this.sub.add(this.jsonDataService.comparePlpData().subscribe({
      next: (res: any) => {
        this.utils.hideLoading()
        this.comparedata = res || [];
        this.paths = this.comparedata.map((item: any) => item.path);
      },
      error: (err: any) => {
        this.utils.hideLoading()
      }
    }));
  }
  getImageData() {
    if (isPlatformBrowser(this.platformId)) {

      const matchedPath = this.matchesAnyPath(); // Get the matched path
      const screenSize = window.innerWidth;

      // Find the matched object in the array
      const matchedData = this.comparedata.find((item: any) => item.path === matchedPath);

      // If a match is found, return image details
      if (matchedData) {
        return {
          imageUrl: screenSize >= 768 ? matchedData.imageWeb : matchedData.imageMobile,
          altText: matchedData.altText,
          description: matchedData.description
        };
      }
    }
    // Default return if no match is found
    return { imageUrl: '', altText: '', description: '' };
  }
  async callSchema() {
    if (isPlatformBrowser(this.platformId)) {

      // Remove existing JSON-LD schema scripts before adding new ones
      this.removeExistingSchema();

      // Generate schema data
      const breadcrumbSchema = this.schemaService.addBreadcrumbSchema();
      const itemlistSchema = this.schemaService.addItemlistSchema();

      // Convert schemas to JSON strings
      const breadcrumbJsonString = JSON.stringify(breadcrumbSchema);
      const itemlistJsonString = JSON.stringify(itemlistSchema);

      // Create and append the breadcrumb schema script
      const breadcrumbScript = this._renderer2.createElement('script');
      breadcrumbScript.type = 'application/ld+json';
      breadcrumbScript.text = breadcrumbJsonString;
      breadcrumbScript.setAttribute('id', 'breadcrumbSchema'); // Unique identifier
      breadcrumbScript.defer = true;
      this._renderer2.appendChild(this._document.body, breadcrumbScript);

      // Create and append the item list schema script
      const itemlistScript = this._renderer2.createElement('script');
      itemlistScript.type = 'application/ld+json';
      itemlistScript.text = itemlistJsonString;
      itemlistScript.setAttribute('id', 'itemlistSchema'); // Unique identifier
      itemlistScript.defer = true;
      this._renderer2.appendChild(this._document.body, itemlistScript);
    }
  }
  // Function to remove existing schema scripts
  private removeExistingSchema() {
    if (isPlatformBrowser(this.platformId)) {

      const breadcrumbScript = this._document.getElementById('breadcrumbSchema');
      if (breadcrumbScript) {
        breadcrumbScript.remove();
      }

      const itemlistScript = this._document.getElementById('itemlistSchema');
      if (itemlistScript) {
        itemlistScript.remove();
      }
    }
  }

  inIt() {

    this.checkedProducts = [];
    this.isCompare = false;
    this.sub.add(this._routeSub = this.route.queryParams.subscribe((params: any) => {
      this.getRequireData(params);
    }));
    if (this.isEshop) {
      this.sub.add(this.eshopCatSub = this.utils.eshopCatList.subscribe((data: any) => {
        if (data && data.length) {
          let filterData = data.filter((ele: any) => { if (ele.eshopCategoryGuidId == this.subCatGuid) return ele });
          if (filterData && filterData[0] && filterData[0].categoryName)
            this.plpText = filterData[0].categoryName;
        }
      }))
    }
  }

  getRequireData(params: any) {
    if (this.utils.filterQueryObj && this.utils.filterQueryObj.apiObjArr && this.utils.filterQueryObj.apiObjArr.length) {
      this.getPlpData(this.utils.filterQueryObj.apiObjArr);
    }
    else {
      let keys = Object.keys(params);
      keys.forEach((element: any) => {
        let idObjArr: any = [];
        idObjArr = element.split('_');
        let valuesOfFilter = params[element].split(',');
        let separatedfilterValue: any = '';
        if (valuesOfFilter && valuesOfFilter.length) {
          valuesOfFilter.forEach((element: any, index: any) => {
            let idArrValue = (element.split('_'));
            separatedfilterValue += (index > 0 ? ',' : '') + Number(idArrValue[idArrValue.length - 1]);
            let tmpObj: any = {
              'filterId': idObjArr[idObjArr.length - 1],
              'filterValue': idArrValue[idArrValue.length - 1]
            };
            if (tmpObj && tmpObj.filterId)
              this.filtersApplied.push(tmpObj);
          });
        }
        else {
          let obj: any = {
          };
          let idArrValue = (valuesOfFilter.split('_'));
          obj['filterId'] = idObjArr[idObjArr.length - 1]
          obj['filterValue'] = idArrValue[idArrValue.length - 1];
          if (obj && obj.filterId)
            this.filtersApplied.push(obj);
        }
      });
      this.sub.add(this.utils.menuList.subscribe((data: any) => {
        this.selectedDataForBreadCrumb = [];
        data.forEach((catData: any) => {
          let obj: any = {};
          let selectedSubCat = catData.brandSubCategoriesMenus.filter((subCatData: any) => {
            if (this.utils.createNameForUrl(subCatData.subCategory) == this.subcatName) {
              return subCatData
            }
          })
          if (selectedSubCat[0] && selectedSubCat[0].guid) {
            obj['guid'] = catData.guid;
            obj['landingPageGuid'] = catData.landingPageGuid;
            obj['category'] = catData.category;
            obj['categoryType'] = catData.categoryType;
            obj['brandSubCategoriesMenus'] = selectedSubCat[0];
            this.selectedDataForBreadCrumb = obj;
            obj['seriesName'] = this.checkSeriesName();
            this.utils.setProductCategoryName(obj);
          }
        })
        if (this.isEshop) {
          let obj: any = {};
          obj['category'] = this.plpText;
          obj['seriesName'] = '';
          obj['brandSubCategoriesMenus'] = { subCategory: '' };
          this.utils.setProductCategoryName(obj);
        }
      }))
      this.utils.showLoading();
      this.sub.add(this.httpSvc.getFilters(this.subCatGuid, this.pageName, this.isEshop).subscribe({
        next: (response: any) => {
          this.utils.hideLoading()
          if (response && response.filterWithValues && response.filterWithValues.length)
            this.filterData = response.filterWithValues;
          else
            this.filterData = []
          this.utils.filterData = [this.staticFilterForSort].concat(this.filterData);
          this.filtersApplied.forEach((element: any) => {
            let filterdObj = this.utils.filterData.filter((x: any) => {
              if (String(x.filterID) == String(element.filterId)) {
                return x;
              }
            })
            if (filterdObj[0]) {
              let filterValues = element.filterValue.split(',');
              for (const filterdValue of filterValues) {
                for (const filterValueToCheck of filterdObj[0].filterValues) {
                  if (filterdObj[0].filterID == 'sb') {
                    if (String(filterdValue) == String(filterValueToCheck.filterValueId)) {
                      filterValueToCheck['checked'] = true;
                    }
                    else {
                      filterValueToCheck['checked'] = false;
                    }
                  }
                  else {
                    if (String(filterdValue) == String(filterValueToCheck.filterValueId)) {
                      filterValueToCheck['checked'] = true;
                    }
                  }
                }
              }
            }
          });
          this.getPlpData(this.filtersApplied);
        }
      }))
    }
    this.utils.hideLoading();

  }

  checkSeriesName() {
    let seriesName: any;
    if (this.selectedDataForBreadCrumb.brandSubCategoriesMenus && this.selectedDataForBreadCrumb.brandSubCategoriesMenus.brandSubSubCategoriesMenu && this.selectedDataForBreadCrumb.brandSubCategoriesMenus.brandSubSubCategoriesMenu.length) {
      for (let subSubCatData of this.selectedDataForBreadCrumb.brandSubCategoriesMenus.brandSubSubCategoriesMenu) {
        if (seriesName)
          break;
        else {
          for (let seriesData of subSubCatData.series) {
            if (this.utils.createNameForUrl(seriesData.series) == this.seriesName) {
              seriesName = seriesData.series
              break;
            }
          }
        }
      }
      if (!seriesName) {
        this.selectedDataForBreadCrumb.brandSubCategoriesMenus.series.forEach((ele: any) => {
          if (this.utils.createNameForUrl(ele.series) == this.seriesName)
            seriesName = ele.series
        })
      }
    }
    if (!seriesName) {
      this.selectedDataForBreadCrumb.brandSubCategoriesMenus.series.forEach((ele: any) => {
        if (this.utils.createNameForUrl(ele.series) == this.seriesName)
          seriesName = ele.series
      })
    }
    return seriesName ? seriesName : '';
  }

  getPlpData(filterDataToApply: any) {
    this.utils.showLoading();
    let body: any = {}
    if ((this.subCatGuid || this.pageName) && !this.seriesGuid && !this.isEshop) {
      body['subCatGuid'] = this.subCatGuid;
      body['brandSubCategoryName'] = this.subcatName
      body['brandCategoryName'] = this.parentName;
    }
    if (this.seriesGuid || this.pageName) {
      body['seriesGuid'] = this.seriesGuid;
      body['seriesName'] = this.seriesName
    }
    if (!this.seriesGuid && !this.subCatGuid && !this.isEshop) {
      body['brandSubCategoryName'] = this.pageName
      body['seriesName'] = this.seriesName
      body['brandCategoryName'] = this.parentName;
    }
    if (this.isEshop) {
      body['eshopGuid'] = this.subCatGuid;
      body['eshopName'] = this.pageName;
    }
    if (filterDataToApply) {
      let filterObjArr: any = []
      let sortBy: any = {}
      for (const filterData of filterDataToApply) {
        if (filterData.filterId != 'sb') {
          if (!Number.isNaN(Number(filterData.filterId))) {
            filterObjArr.push(filterData);
          }
        }
        else {
          let sortByObj = this.staticFilterForSort.filterValues.filter((x: any) => { if (x.filterValueId == filterData.filterValue) return x })
          if (sortByObj[0]) {
            sortBy['sortBy'] = sortByObj[0].filterValue.toLowerCase();
            sortBy['sortByDescending'] = sortByObj[0].sortByDescending;
          }
        }
      }
      if (filterObjArr && filterObjArr.length)
        body['filterData'] = filterObjArr;
      if (sortBy && sortBy.sortBy)
        body['sortBy'] = sortBy;
      else {
        let obj: any = {};
        obj['sortBy'] = this.staticFilterForSort.filterValues[0].filterValue.toLowerCase();
        obj['sortByDescending'] = this.staticFilterForSort.filterValues[0].sortByDescending;
        body['sortBy'] = obj;
      }
    }
    if (this.utils.getUserPicode()) {
      body['pinCode'] = this.utils.getUserPicode() ? this.utils.getUserPicode() : '';
    }


    this.sub.add(this.httpSvc.getPlpData(body, this.isEshop).subscribe({
      next: (res: any) => {
        if (res.success) {

          this.productList = [];
          this.productList = res.productDetails;
          const { productName } = this.productList;
          const filteredObject = { productName };
          this.schemaService.sendData(filteredObject);
          this.callSchema();
          // this.callCrouselSchema();
          if (this.productList.length) {
            this.triggerViewListEvent(body);
          }
          this.faqData = res.questionAnswer && res.questionAnswer.length ? res.questionAnswer : [];
        }
        else {
          this.productList = [];
          this.utils.hideLoading()
          this.router.navigate(['/not-found'])
        }
        this.utils.hideLoading();
      }
    }))
  }

  triggerViewListEvent(filter: any) {
    let itemArray = this.productList.map((data: any, index: number) => {

      return {
        'item_id': data.productSku,
        'item_name': data.productName,
        'item_brand': this.seriesName || this.subcatName,
        'currency': 'INR',
        'discount': data.productDiscountedPrice !== 0 ? (data.productPrice - data.productDiscountedPrice) : 0,
        'item_category': this.parentName,
        'item_category2': this.subcatName,
        'item_category4': data.vaRating || '',
        'item_category5': data.technology || '',
        'price': data.productDiscountedPrice !== 0 ? data.productDiscountedPrice : data.productPrice,
        'item_list_name': filter?.filterData?.length ? 'filter' : 'sort',
        'item_list_id': 'NA',
        'item_variant': data.warranty || '',
        'index': index,
      }
    });
    this.dataLayerService.triggerEvents(itemArray, 'view_item_list')
  }

  opneFilterModel() {
    this.filterData['isFilterSection'] = true;
    if (this.utils.screenSizeObj.width < 768) {
      const dialogRef = this.dialog.open(SharedModelComponent, {
        disableClose: true,
        panelClass: 'filterModel',
        data: this.filterData
      });
      this.sub.add(dialogRef.afterClosed().subscribe((res: any) => {
      }));
    }
  }

  openPinCodeModel() {
    const dialogRef = this.dialog.open(ChooseLocationModalComponent, {
      disableClose: true,
      data: this.utils.getUserPicode()
    });
    this.sub.add(dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.getPlpData(this.getQueryString().apiObjArr);
      }
    }));
  }

  getQueryString() {
    let queryObj: any = {};
    let apiObj: any = [];
    this.utils.filterData.forEach((element: any) => {
      let value: any = '';
      element.filterValues.forEach((ele: any) => {
        if (ele.checked) {
          value += (value.length ? ',' : '') + ele.filterValue.toLowerCase().split(' ').join('-') + '_' + ele.filterValueId;
          let obj: any = {
            filterId: '',
            filterValue: ''
          };
          obj.filterId = element.filterID
          obj.filterValue = ele.filterValueId
          apiObj.push(obj);
        }
      });
      if (value.length) {
        queryObj[`${element.filterDisplayNames.toLowerCase().split(' ').join('-')}_${element.filterID}`] = value;
      }
    });
    return { queryObj: queryObj, apiObjArr: apiObj };
  }

  getCategoryRoute() {
    let url = "";
    let catTitle = this.utils.createNameForUrl(this.selectedDataForBreadCrumb.category);
    if (this.selectedDataForBreadCrumb.categoryType && this.selectedDataForBreadCrumb.categoryType.toLowerCase() == 'inbt') {
      url = `/category/energy-storage/${catTitle}`;
    }
    else {
      url = `/category/solar/${catTitle}`;
    }
    return url;
  }
  subCatCLickHandler() {
    if (!this.seriesName) {
      this.reloadPage();
    }
    else {
      let subCatData: any = this.selectedDataForBreadCrumb.brandSubCategoriesMenus;
      this.router.navigate(['product-listing', this.utils.createNameForUrl(this.selectedDataForBreadCrumb.category), this.utils.createNameForUrl(subCatData.subCategory)])
    }
  }

  getSubCatRoute() {
    let subCatData: any = this.selectedDataForBreadCrumb.brandSubCategoriesMenus;
    let url = '';
    if (this.seriesName || (this.selectedDataForBreadCrumb.category && subCatData.subCategory)) {
      url = `/product-listing/${this.utils.createNameForUrl(this.selectedDataForBreadCrumb.category)}/${this.utils.createNameForUrl(subCatData.subCategory)}`;
    }
    else {
      url = this.router.url;
    }
    return url;
  }

  compareProducts() {
    if (this.isCompare && this.checkedProducts.length == 2) {
      this.router.navigate(['/compare-products', this.pageName, ...this.checkedProducts])
    }
    else {
      this.isCompare = true
    }
  }

  onProductsSubmit(products: any) {
    if (products.flag) {
      this.checkedProducts.push(products.value)
    }
    else {
      this.checkedProducts = this.checkedProducts.filter((prod: any) => { return prod != products.value })
    }
    if (this.checkedProducts && this.checkedProducts.length >= 2) {
      this.utils.isCheckedLimit = true
    }
    else {
      this.utils.isCheckedLimit = false
    }
  }

  reloadPage() {
    location.reload();
  }

  ngOnDestroy(): void {
    if (this._routerSub) this._routerSub.unsubscribe();
    if (this._routeSub) this._routeSub.unsubscribe();
    if (this.eshopCatSub) this.eshopCatSub.unsubscribe();
    this.sub.unsubscribe()
  }

  // callCrouselSchema() {
  //   let productListschemaarr: any = [];
  //   if (isPlatformBrowser(this.platformId)) {
  //     this.productList.forEach((ele: any, index) => {
  //       let Productname = this.utils.createNameForUrl(ele.productName ? ele.productName : '')
  //       let tempObj = {
  //         "@type": "ListItem",
  //         "position": index + 1,
  //         "name": ele.productName,
  //         "url": `https://www.luminousindia.com/product/${Productname}`
  //       }
  //       productListschemaarr.push(tempObj)
  //     })
  //     let schemaobj = {
  //       "@context": "https://schema.org/",
  //       "@type": "ItemList",
  //       "itemListElement": productListschemaarr
  //     }

  //     this.structuredData = this.sanitizer.bypassSecurityTrustHtml(`
  //       <script type="application/ld+json">
  //         ${JSON.stringify(schemaobj)}
  //       </script>
  //     `);
  //   } else { }

  // }
}
